import './Stepper.css';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

function getIcon({ count }) {
  return count;
}

const StepperItem = ({
  children,
  completed = false,
  count,
  currentStep,
  first = false,
  last = false,
  linkTo,
  onClick,
  disableText = false,
  wrapperClassName = '',
}) => {
  const icon = getIcon({
    count,
    currentStep,
    completed,
    last,
  });
  return (
    <span
      className={classNames(
        !linkTo && 'pointer-events-none',
        'stepper__link',
        first && 'stepper__link--first',
        last && 'stepper__link--last',
        wrapperClassName,
      )}
    >
      <Link to={linkTo} onClick={onClick} className='stepper-link'>
        <span
          className={classNames(
            'stepper__count',
            count === currentStep
              ? 'stepper__count--active'
              : (count < currentStep || (count === currentStep && last)) &&
                  'bg-white',
            (count === currentStep || count < currentStep) &&
              'stepper__count--not-done',
            count < currentStep && 'stepper__count--previous',
          )}
        >
          {icon}
        </span>
        {!disableText ? (
          <span
            className={classNames(
              'stepper__text',
              count === currentStep && 'stepper__text--active',
              (count <= currentStep || (count === currentStep && last)) &&
                'stepper__text--done',
            )}
          >
            {children}
          </span>
        ) : null}
      </Link>
    </span>
  );
};

StepperItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  completed: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  count: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  disableText: PropTypes.bool,
  first: PropTypes.bool,
  last: PropTypes.bool,
  linkTo: PropTypes.string,
  onClick: PropTypes.func,
  wrapperClassName: PropTypes.string,
};

export default StepperItem;
